import React from "react";
import { getCssVariableValue } from "./cssVariablesValue/cssUtils";
const SpeakQuestionSvg = ({ section_status, isLastIndex }) => {
  
  let svg_fill_color = getCssVariableValue('--background-color');

  return (
    <>
      {section_status === "completed" ? (
        <svg
          className="pb-1"
          width="24"
          height="62"
          viewBox="0 0 24 62"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_448_8)">
            <path
              d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z"
              fill="#F9F5FF"
            />
            <path
              d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z"
              fill={svg_fill_color}
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M17.096 7.39004L9.93602 14.3L8.03602 12.27C7.68602 11.94 7.13602 11.92 6.73602 12.2C6.34602 12.49 6.23602 13 6.47602 13.41L8.72602 17.07C8.94602 17.41 9.32601 17.62 9.75601 17.62C10.166 17.62 10.556 17.41 10.776 17.07C11.136 16.6 18.006 8.41004 18.006 8.41004C18.906 7.49004 17.816 6.68004 17.096 7.38004V7.39004Z"
              fill="white"
            />
          </g>
          {!isLastIndex && (
          <path
            d="M11 29C11 28.4477 11.4477 28 12 28C12.5523 28 13 28.4477 13 29V61C13 61.5523 12.5523 62 12 62C11.4477 62 11 61.5523 11 61V29Z"
            fill={svg_fill_color}
          />
          )}
          <defs>
            <clipPath id="clip0_448_8">
              <path
                d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z"
                fill="white"
              />
            </clipPath>
          </defs>
        </svg>
      ) : section_status === "active" ? (
        <svg
          width="24"
          height="62"
          viewBox="0 0 24 62"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="pb-1"
        >
          <g clipPath="url(#clip0_448_8)">
            <path
              d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z"
              fill={svg_fill_color}
            />
            <path
              d="M0.75 12C0.75 5.7868 5.7868 0.75 12 0.75C18.2132 0.75 23.25 5.7868 23.25 12C23.25 18.2132 18.2132 23.25 12 23.25C5.7868 23.25 0.75 18.2132 0.75 12Z"
              stroke={"white"}
              strokeWidth="5.5"
            />
            <path
              d="M0.75 12C0.75 5.7868 5.7868 0.75 12 0.75C18.2132 0.75 23.25 5.7868 23.25 12C23.25 18.2132 18.2132 23.25 12 23.25C5.7868 23.25 0.75 18.2132 0.75 12Z"
              stroke={svg_fill_color}
              strokeWidth="2.5"
            />
            <circle cx="12" cy="12" r="4" fill={"white"} />
          </g>
          {!isLastIndex && (
          <path
            d="M11 29C11 28.4477 11.4477 28 12 28C12.5523 28 13 28.4477 13 29V61C13 61.5523 12.5523 62 12 62C11.4477 62 11 61.5523 11 61V29Z"
            fill={svg_fill_color}
          />
          )}
        </svg>
      ) : (
        <svg
          className="pb-1"
          width="24"
          height="62"
          viewBox="0 0 24 62"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0_448_8)">
            <path
              d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z"
              fill="#F9FAFB"
            />
            <path
              d="M0.75 12C0.75 5.7868 5.7868 0.75 12 0.75C18.2132 0.75 23.25 5.7868 23.25 12C23.25 18.2132 18.2132 23.25 12 23.25C5.7868 23.25 0.75 18.2132 0.75 12Z"
              stroke="#E4E7EC"
              stroke-width="1.5"
            />
            <circle cx="12" cy="12" r="4" fill="#D0D5DD" />
          </g>
          {!isLastIndex && (
            <path
              d="M11 29C11 28.4477 11.4477 28 12 28C12.5523 28 13 28.4477 13 29V61C13 61.5523 12.5523 62 12 62C11.4477 62 11 61.5523 11 61V29Z"
              fill="#E4E7EC"
            />
          )}

          <defs>
            <clipPath id="clip0_448_8">
              <path
                d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z"
                fill="white"
              />
            </clipPath>
          </defs>
        </svg>
      )}
    </>
  );
};

export default SpeakQuestionSvg;
